
    import * as React from 'react';

    const ChevronLeftCircle40 = ({ color = 'currentcolor', height = '40px', width = '40px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 40 40" fill="none" style={svgStyle}><g><path fillRule="evenodd" clipRule="evenodd" d="M39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39C30.4934 39 39 30.4934 39 20ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" /><path fillRule="evenodd" clipRule="evenodd" d="M15.2928 20L23.6464 11.6465L24.3535 12.3536L16.7071 20L24.3535 27.6465L23.6464 28.3536L15.2928 20Z" /></g></svg>
        </div>
      );
    };

    ChevronLeftCircle40.displayName = 'ChevronLeftCircle40';

    export default ChevronLeftCircle40;
  